<div class="municipality-info-column">
  <div class="body-3">{{ row.name }}</div>
  <div class="body-3">{{ row.ags }}</div>
  <div class="body-3">Konzession:&nbsp;{{ row.concession }}</div>
</div>
